import React from "react";
import { Box, Grid } from "@material-ui/core";

import { Layout, Section } from "../components";

function FitnessTrackerAPI() {
  return (
    <Layout>
      <Box my={12}>
        <Section>
          <Box className="projectDetails">
            <Box className="banner">Fitness Tracker Backend</Box>
            <Box mt={4} className="title">
              Description
            </Box>
            <Box mt={2}>
              <Box my={1}>
                • Developed cross-platform MERNG mobile application on iOS and
                Android, designed user interface with Adobe Xd.
              </Box>
              <Box my={1}>
                • Developed a backend using Node.js and Express, implemented an
                access control system with JSON web token, storage and
                management of user’s profile, activity and meal data on MongoDB,
                and user data query and mutation service via GraphQL.
              </Box>
              <Box my={1}>
                • Developed a mobile application using React Native that
                consumes backend APIs to allows users to manage accounts, log
                activities and meals, and visualize daily and weekly progress
                with SVG Charts from d3.js.
              </Box>
            </Box>
            <Box mt={4} className="title">
              Tech Stacks
            </Box>
            <Box mt={1}>
              JavaScript (ES6), Node.js, Express, MongoDB, RESTful API, GraphQL,
              cors, JSON web token, base64, mongoose, dotenv, Postman, Google
              Cloud Platform, VS Code
            </Box>
          </Box>
        </Section>
      </Box>
    </Layout>
  );
}

export default FitnessTrackerAPI;
